export const Errornotf = ({ message, type, ...rest }: any) => {
  return (
    <>
      {message ? (
        <div {...rest} className={`notification ${type || "danger-not"}`}>
          <p className="text-p1 font-medium">{message}</p>
        </div>
      ) : null}
    </>
  );
};
